import React from 'react';
import Chart, {Props} from 'react-apexcharts';
import Spinner from '../Spinner';

type ComponentCustomClassnames = {
  container: string
  header: string
  spinner: string
};

export interface StylesChartComponentProps extends Props {
  customClassnames: ComponentCustomClassnames,
  options?: any,
  header?: string | React.ReactNode;
  loading?: boolean
}

export const ChartView = ({
                            customClassnames,
                            header,
                            type,
                            width,
                            height,
                            options,
                            loading
                          }: StylesChartComponentProps) => {
  const showChartCondition = !loading && Boolean(options.series[0].data) && options.series[0].data.length > 0;

  return (
    <div className={customClassnames.container}>
      <div className={customClassnames.header}>
        {header}
      </div>
      {showChartCondition
        ? (
          <Chart
            options={options}
            series={options.series}
            type={type}
            width={width}
            height={height}
          />
        )
        : (
          <div className={customClassnames.spinner}>
            <Spinner/>
          </div>
        )
      }
    </div>
  );
};